/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import FormItemAutoComplete from "../form/input/FormItemAutocomplete";

function TkProcessTempleteSelectList(props) {

    const {
        onSelectTempleteChange,
        createdTempleteId,
        checkProcessSameTempleteId
    } = props;

    const [templeteId, setTempleteId] = useState("");

    const [autoCompleteInfo, setAutoCompleteInfo] = useState({

        codeInfo : {
            tableName: "TkProcessTemplete",
            nameColumn: "processTempleteName",
            valueColumn: "templeteId",
            useEmptyValue: true,
            emptyName: "term.none",
            sortByName: true,
        },
    }) 


    useEffect(()=>{

        setAutoCompleteInfo((prevData)=>{

            let newData = {...prevData};

            return newData;

        })

        if(createdTempleteId) {
            
            setTempleteId(createdTempleteId);

            onSelectTempleteChange(createdTempleteId)

        }
        
    },[createdTempleteId])

    useEffect(()=>{
        if(checkProcessSameTempleteId || checkProcessSameTempleteId === "") {
            setTempleteId(checkProcessSameTempleteId);
        }
        
    },[checkProcessSameTempleteId])

    const onChange = (templeteId)=> {
        setTempleteId(templeteId)

        if(onSelectTempleteChange) {

            onSelectTempleteChange(templeteId)
        }
    }

    return (
        <>
            <span
                style={{
                    display: "inline-block",
                    height: "16px",
                    paddingLeft: "15px",
                    paddingTop: "7px",
                    marginRight: "2px",
                    fontWeight : "bold",
                }}
                >
                템플릿 :
            </span>
            <FormItemAutoComplete
                style = {{
                    width : "130px",

                }}
                column = {autoCompleteInfo}
                value = {templeteId}
                onChange = {onChange}
                InputLabelProps = {{
                    style : {
                        fontSize : "large",
                        fontWeight : "bold",
                }}}
            />
        </>
    );
}

export default TkProcessTempleteSelectList;
